import { z } from 'zod'

// 탭① 기본단가 — 검색 필터 (국가 / 서비스 항목 / 단위 / 주문유형, 모두 전체 포함·PRD §5-1-2)
export const basePriceListSchema = z.object({
  country: z.string().nullable(),
  serviceType: z.string().nullable(),
  unitType: z.string().nullable(),
  orderType: z.string().nullable(),
})

export type BasePriceListSchemaType = z.infer<typeof basePriceListSchema>

export const getInitForm = (parsedQs: Partial<BasePriceListSchemaType> = {}): BasePriceListSchemaType => {
  return {
    country: parsedQs.country ?? null,
    serviceType: parsedQs.serviceType ?? null,
    unitType: parsedQs.unitType ?? null,
    orderType: parsedQs.orderType ?? null,
  }
}
